export default __webpack_public_path__ + "static/media/linkclicks.cd85e9a5.png";